import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING, VIEW, ASC } from "const"
import { MtProject } from "server/models"
import {
    StateType,
    hasProjectAccess,
} from "client/utils"
import {
    PRM_SIL_SAFETY_FUNCTION,
    StoreType,
    SilSafetyFunctionProps,

    LoadAllProjects,
    LoadProjectUserGroups,
    LoadProjectPermissions,
    LoadSilSafetyFunctionById,
    SortProjects,

    setProjectList,
    setProjectIds,
    setSystemProjectUserGroups,
    setSystemProjectPermissions,
    setSilSafetyFunctionView,
    setSilSafetyFunctionSubsystemList,

    moduleIds,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    Loader,
} from "client/components"

import AccessDenied from "client/parts/accessDenied"
import NotFound from "client/parts/notFound"
import Form from "./form"
import Model from "./model"

const View = ({
    safetyFunctionId = null,
}: SilSafetyFunctionProps) => {
    const safetyFunction = useSelector((state: StoreType) => state.silSafetyFunction.safetyFunctionView)
    const reloadView = useSelector((state: StoreType) => state.silSafetyFunction.reloadView)
    const project = useSelector((state: StoreType) => state.project.projectView)

    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadCopyState, setLoadCopyState] = useState<StateType>(IDLE)
    const [loadState, setLoadState] = useState<StateType>(IDLE)

    useEffect(() => {
        // load data for Copy function
        setLoadCopyState(PENDING)
        LoadAllProjects(userData.accountId).then((res) => {
            dispatch(setProjectList(res))

            const projectsWithSil: MtProject[] = []
            Object.values(res).forEach((row) => {
                const projectModules = JSON.parse(row.modules)
                if (projectModules[moduleIds.sil]) projectsWithSil.push(row)
            })

            const sortedIds = SortProjects(projectsWithSil, "name", ASC, {})
            dispatch(setProjectIds(sortedIds))

            const promiseArray: Promise<any>[] = []
            projectsWithSil.forEach((projectRow) => {
                promiseArray.push(
                    // to check user access to selected project
                    LoadProjectUserGroups(userData.userId, userData.accountId, projectRow.id)
                    .then((projectGroupIds) => {
                        dispatch(setSystemProjectUserGroups(projectRow.id, projectGroupIds))
                    }),
                    LoadProjectPermissions(userData.accountId, projectRow.id)
                    .then((permissions) => {
                        dispatch(setSystemProjectPermissions(projectRow.id, permissions.permissions))
                    }),
                )
            })
            Promise.all(promiseArray).then(() => {
                setLoadCopyState(IDLE)
            })
        })
    }, [])

    useEffect(() => {
        if (!reloadView) return
        setLoadState(PENDING)
        LoadSilSafetyFunctionById(safetyFunctionId, project.id).then((res) => {
            dispatch(setSilSafetyFunctionView(res))
            dispatch(setSilSafetyFunctionSubsystemList(res.subsystems))
        }).then(() => {
            setLoadState(IDLE)
        })
    }, [reloadView])

    const viewAccess = hasProjectAccess(PRM_SIL_SAFETY_FUNCTION, VIEW)

    if (!viewAccess) return <AccessDenied />
    if (!safetyFunction) return <NotFound />
    return (
        <Container>
            <PageHeader>
                <PageTitle>{`${lang.viewSafetyFunction} # ${safetyFunction.id || ""}`}</PageTitle>
            </PageHeader>
            <PageContent>
                {
                    (
                        loadCopyState === PENDING
                        || loadState === PENDING
                    ) && <Loader />
                }
                <Form />
                <Model />
            </PageContent>
        </Container>
    )
}
export default View
